import { useState, useEffect } from 'react';
import { usePrevious } from '@mafc/hooks';

import { ServiceEntriesType } from 'network/response/ICart';

const useExtendedWarranty = (
  serviceEntries: ServiceEntriesType,
  quantity: number
): [ServiceEntriesType] => {
  const prevQuantity = usePrevious(quantity);
  const [entries, setEntries] = useState<ServiceEntriesType>([]);

  useEffect(() => {
    setEntries(serviceEntries);
  }, [prevQuantity > quantity]); // eslint-disable-line  react-hooks/exhaustive-deps

  return [entries];
};

export default useExtendedWarranty;
